// client/src/pages/news/newsChromeWithData.js
import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';

const NEWS_CHROME_QUERY = gql`
  query newsPageQuery {
    newsPages {
      backgroundHeader
      backgroundDescription
      newsHeader
      backgroundImage {
        title
        description
        url
      }
    }

    exploreComponents {
      isNotDisplayed
      exploreTitle
      exploreTile {
        backgroundImage {
          title
          description
          url
        }
        route
        title
        ctaText
      }
    }

    globalSites {
      cubsLogo {
        title
        url
      }
      mainNavigation {
        footerHeader
        footerBody
        copyrightHolder
        primaryNavigationLinks { route text }
        seasonalPrimaryNavigationLinks { route text }
        footerLinks { route text }
        seasonalFooterLinks { route text }
        secondaryFooterLinks { route text }
        footerLogo { title description url }
      }
    }
  }
`;

export default function newsChromeWithData(WrappedComponent) {
  return graphql(NEWS_CHROME_QUERY, {
    // keep the same prop name your page expects
    name: 'newsPageQuery',
    options: {
      // attempt a fresh network request; ensure data is populated even if some fields error
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    }
  })(WrappedComponent);
}
